import { createTheme } from "@mui/material";

const CustomTheme = createTheme({
  palette: {
    primary: {
      main: "#E0DFDF",
    },
    background: {
      default: "#FDF6E3",
      paper: "#4C4546",
    },
    text: {
      primary: "#4C4546",
      secondary: "#FFFFFF",
    },
  },
  typography: {
    fontFamily: "Gill Sans Nova",
  },
});

export default CustomTheme;
